import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./stores/store";
import AuthProvider from "./providers/AuthProvider";
import WebServerProvider from "./providers/WebServerProvider";
import LocalTimeProvider from "./providers/LocalTimeProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  <AuthProvider>
    <Provider store={store}>
      <WebServerProvider>
        <LocalTimeProvider>
          <App />
        </LocalTimeProvider>
      </WebServerProvider>
    </Provider>
  </AuthProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
